import { Trans } from "react-i18next";
import { Stack, Typography } from "@mui/material";
import { formatInstallationDate } from "@utils/dateFormat";

interface IParams {
    serviceDate: Date;
}

export const InstallationPreOrder = (props: IParams) => {
    const { serviceDate } = props;

    return (
        <Stack spacing={2}>
            <Typography color="secondary" component="p" fontWeight={400} gutterBottom variant="normal">
                <Trans
                    i18nKey="preOrderInfo"
                    ns="installation"
                    values={{ serviceDate: formatInstallationDate(serviceDate) }}
                />
            </Typography>
        </Stack>
    );
};
